import { useSelector } from 'react-redux';

import { selectScoreMatrixState } from '@lib/core/quizzes/selectors/scoreMatrix';

export const useScoreMatrix = () => {
  return {
    scoreMatrix: useSelector(selectScoreMatrixState),
  };
};
